<!-- Update 01/04/22 -->
<div class="grid">
    <div class="col-12 grid">
      <div class="col-12">
        <h3 class="text-sm">
          {{ 'Validaciones' | translate }}:
          <em>{{ today | date }}</em>
        </h3>
      </div>
      <div class="col-12 lg:col-6 md:col-6 sm:col-12">
        <kanzi-count-widget
          [type]="validationType1"
          [description]="description1"
          [path]="path"
          [filter]="filter1"
        ></kanzi-count-widget>
      </div>
      <div class="col-12 lg:col-6 md:col-6 sm:col-12">
        <kanzi-count-widget
          [type]="validationType2"
          [description]="description2"
          [path]="path"
          [filter]="filter2"
        ></kanzi-count-widget>
      </div>
    </div>
  </div>
  